import {Component, OnInit} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {ColDef, ColGroupDef, GridOptions} from "ag-grid-community";
import {takeWhile} from "rxjs/operators";
import AppConstants from "../../shared/common-components/AppConstants";
import {IffShipmentDetailsService} from "../../services/iff-shipment-details/iff-shipment-details.service";
import {Router} from "@angular/router";
import {LoadingService} from "../../services/loading/loading.service";
import {HhgOnlineBookShipmentService} from "../hhg-online-book-shipment/hhg-online-book-shipment.service";
import {AlertService} from "../../services/alert/alert.service";

@Component({
    selector: 'app-frt-ontime-shipment-reports',
    imports: [
        AgGridAngular,
        FormsModule,
        NgForOf,
        ReactiveFormsModule,
        NgIf
    ],
    templateUrl: './frt-ontime-shipment-reports.component.html',
    styleUrl: './frt-ontime-shipment-reports.component.css'
})
export class FrtOntimeShipmentReportsComponent implements OnInit{
  frtOnTimeFormGroup: UntypedFormGroup;
  currentYear: any = 0;
  years = [];
  onTimeReports: any;
  gridOptions: GridOptions = this.initializeGridOptions();
  private gridApi;
  columnDefs: any;
  public overlayNoRowsTemplate;
  rowData: any;
  grid: GridOptions;
  columnsDefs: any;



  frtShipmentSummaryColumnDefs: (ColDef | ColGroupDef)[] = [
    <ColDef>
    {
      headerName: 'SCAC',
      field: 'scac',
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      headerName: 'TSP Name',
      field: 'scacName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'On Time Delivery %',
      field: 'onTimeDeliveryPct',
      filter: 'agTextColumnFilter',
      headerTooltip: 'On-time delivered shipments/ Total shipments with no delivery code exceptions',
      sortable: true
    },
    {
      headerName: 'On Time Pickup %',
      field: 'onTimePickUpPct',
      filter: 'agTextColumnFilter',
      headerTooltip: 'On-time pick-up shipments/ Total shipments with no delivery code exceptions',
      sortable: true
    },
    {
      headerName: 'Email',
      field: 'email',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Phone',
      field: 'phone',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Total Shipments',
      field: 'totalShipments',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'SRO ID',
      field: 'sroId',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'SRO Notes',
      field: 'sroNotes',
      filter: 'agTextColumnFilter',
      sortable: true
    }
  ];

  getRowHeight(params) {
    return 35;
  }

  constructor(
    private shipmentDetailService: HhgOnlineBookShipmentService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private loader: LoadingService
  ) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No results found. Please adjust your filters.</span>';
  }

  ngOnInit() {
    this.frtOnTimeFormGroup = this.fb.group({
      reportingYrSelect: new UntypedFormControl('', Validators.required),
    });
    this.loadingYears();
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      rowHeight: 45,
      headerHeight: 80,
      rowData: this.onTimeReports,
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.rowData);
    params.api.sizeColumnsToFit();
  }

  loadingYears() {
    this.currentYear = new Date().getFullYear();
    this.frtOnTimeFormGroup.get('reportingYrSelect').setValue(this.currentYear);
    this.years.push({name: this.currentYear, value: this.currentYear});
    for (let i = 1; i < 4; i++) {
      const previousYr = this.currentYear - i;
      this.years.push({name: previousYr, value: previousYr});
    }
    this.getFRTOnTimeDetailsDetails();
  }

  getFRTOnTimeDetailsDetails(){
    this.loader.show();
   this.shipmentDetailService.getFrtOnTimeResults(this.frtOnTimeFormGroup.get('reportingYrSelect').value).subscribe(res => {
      console.log ("res.length "+ res.length);
      if (res.length > 0) {
        this.rowData = res;
        this.loader.hide();
      }else{
        this.rowData =null;
        this.loader.hide();
      }
    }, error => {
     this.loader.hide();
     this.alertService.error('Error while getting report. Please contact system administrator.');
   });
  }

}
